import api from './api/api';

export const listar = () => {
  return api().get(`/modeloMensagem/findAll`);
}

export const cadastrar = (m) => {
  return api().post(`/modeloMensagem/cadastrar`, m);
}

export const editar = (m) => {
  return api().put(`/modeloMensagem/alterar`, m);
}

export const deletar = (id) => {
  return api().delete(`/modeloMensagem/deletar/${id}`);
}

export const pesquisar = (search) => {
  return api().get(`/modeloMensagem/findBySearch/${search}`);
}
